module.exports = __webpack_public_path__ + "static/media/Team 2 Womies - Sheersh Chetal.e7eb1516.jpg";